/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
import React from 'react'
import './ReviewFooter.css'
import ButtonComponent from '@components/base/button/Button'
import { BUTTON_CONFIGS } from '../../constants'

const BUTTONS = BUTTON_CONFIGS.reviewFooter

const ReviewFooter = ({
  onDiscard = () => {},
  onProceed = () => {},
  disableDiscard = false,
  disableProceed = false,
}) => (
  <div className="review-footer-container">
    <ButtonComponent
      Field={{
        fieldValue: BUTTONS?.DISCARD?.fieldValue,
        fieldLabel: BUTTONS?.DISCARD?.fieldLabel,
        variant: BUTTONS?.DISCARD?.variant,
        disabled: disableDiscard,
      }}
      id={BUTTONS?.DISCARD?.id}
      dataTestId={BUTTONS?.DISCARD?.dataTestId}
      className={BUTTONS?.DISCARD?.className}
      onClickHandler={onDiscard}
    />
    <ButtonComponent
      Field={{
        fieldValue: BUTTONS?.PROCEED?.fieldValue,
        fieldLabel: BUTTONS?.PROCEED?.fieldLabel,
        variant: BUTTONS?.PROCEED?.variant,
        disabled: disableProceed,
      }}
      id={BUTTONS?.PROCEED?.id}
      dataTestId={BUTTONS?.PROCEED?.dataTestId}
      className={BUTTONS?.PROCEED?.className}
      onClickHandler={onProceed}
    />
  </div>
)

export default ReviewFooter
